export default {
	getAccounts: (state) => {
		return state.accounts;
	},
	// getActiveAccounts: (state, _, rootState) => {
	// 	return getActiveAccounts(state, rootState);
	// },
	getAssignedAccounts: (state) => {
		return state.assignedAccounts;
	},
	getAllowUsersMerchandise: (state) => (accountId) => {
		const account = state.accounts.find((a) => a.accountId == accountId);
		return !!(account && account.allowUsersMerchandise);
	},
};

// function getActiveAccounts(state, rootState) {
// 	const accounts = state.accounts.filter((account) => 
// 		account.accountStatus === "Open" && isTreasurerOrConsultant(account, rootState)
// 	);

// 	return accounts.sort((a, b) => a.accountName.localeCompare(b.accountName));
// }

// function isTreasurerOrConsultant(account, rootState) {
// 	const permissionLevels = rootState.auth.permissionLevels;
// 	return account.permissionLevel === permissionLevels.treasurer ||
// 	account.permissionLevel === permissionLevels.consultant;
// }